<template>
    <div class="nav_ynjc">
        <ul>
            <li><router-link  :class="{ nav_sel_ynjc: $route.path==='/' }"  :to="{ path: '/'}">   首&nbsp;&nbsp;页  </router-link></li>
            <li>
                <a href="javascript:;" target="_self">信息系统</a>
                <!--快捷入口-->
                <div class="qucikLinks_ynjc">
                    <ul>
                        <li><a href="#" @click="openTarget(ZRPX)" ><span class="qls_ico_ynjc xcyszr_ico"></span><span class="qls_text_ynjc">乡村医生准入<br>培训和考核系统</span></a></li>
                        <li><a href="#" @click="openTarget(ZCXX)" ><span class="qls_ico_ynjc xcyszy_ico"></span><span class="qls_text_ynjc">乡村医生执业注册<br>信息管理系统</span></a></li>
                        <li><a href="#" @click="openTarget(BMGL)" ><span class="qls_ico_ynjc jcwsry_ico"></span><span class="qls_text_ynjc">基层卫生人员<br>培训报名管理系统</span></a></li>
                        <li><a href="#" @click="openTarget(GWPX)" ><span class="qls_ico_ynjc xcysgw_ico"></span><span class="qls_text_ynjc">乡村医生岗位<br>培训和考核系统</span></a></li>
                        <li><a href="#" @click="openTarget(DAXX)" ><span class="qls_ico_ynjc jcylws_ico"></span><span class="qls_text_ynjc">基层医疗卫生机构<br>档案信息管理系统</span></a></li>
                    </ul>
                </div>
            </li>
            <li><router-link  :class="{ nav_sel_ynjc: $route.path==='/notice' }"  :to="{ path: '/notice'}">   通知公告  </router-link></li>
            <li><router-link  :class="{ nav_sel_ynjc: $route.path==='/latestNews' }"  :to="{ path: '/latestNews'}">   新闻动态  </router-link></li>
            <li><router-link  :class="{ nav_sel_ynjc: $route.path==='/about' }"  :to="{ path: '/about'}">   关于平台  </router-link></li>
        </ul>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                ZRPX: process.env.VUE_APP_API_ZRPX_URL,
                ZCXX: process.env.VUE_APP_API_ZCXX_URL,
                BMGL: process.env.VUE_APP_API_BMGL_URL,
                GWPX: process.env.VUE_APP_API_GWPX_URL,
                DAXX: process.env.VUE_APP_API_DAXX_URL
            }
        },
        methods: {
            openTarget(url){
                window.open(url);
            }
        }
    }
</script>
